import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';
import { ListUserProfileComponent } from './list-user-profile/list-user-profile.component';
import { CreateUserProfileComponent } from './create-user-profile/create-user-profile.component';
import { UpdateUserProfileComponent } from './update-user-profile/update-user-profile.component';
import { ShowUserProfileComponent } from './show-user-profile/show-user-profile.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_USER_PROFILE },
    component: ListUserProfileComponent
  },
  {
    path: 'create',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_USER_PROFILE },
    component: CreateUserProfileComponent
  },
  {
    path: ':id',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_USER_PROFILE },
    component: ShowUserProfileComponent
  },
  {
    path: ':id/update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_USER_PROFILE },
    component: UpdateUserProfileComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserProfileRoutingModule {}
